import { Trip } from '../../types';

export const mockTrips: Trip[] = [
  {
    id: '1',
    title: 'سفر به استانبول',
    origin: 'تهران',
    destination: 'استانبول',
    description: 'سفر ۵ روزه با دوستان - اقامت در هتل میدان تکسیم و گشت تنگه بسفر',
    image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=800&auto=format&fit=crop',
    startDate: '2026-08-01',
    endDate: '2026-08-06',
    visibility: 'private',
    status: 'planning',
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-06-15T10:00:00.000Z',
  },
  {
    id: '2',
    title: 'تور شمال و کلاردشت',
    origin: 'تهران',
    destination: 'مازندران',
    description: 'اقامت در ویلای ساحلی نوشهر و جنگل‌نوردی کلاردشت',
    image: 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=800&auto=format&fit=crop',
    startDate: '2026-07-20',
    endDate: '2026-07-25',
    visibility: 'public',
    status: 'upcoming',
    createdAt: '2026-05-10T10:00:00.000Z',
    updatedAt: '2026-06-01T10:00:00.000Z',
  },
  {
    id: '3',
    title: 'سفر تفریحی و خرید به کیش',
    origin: 'تهران',
    destination: 'کیش',
    description: 'سفر تفریحی به همراه غواصی، شاتل و مراکز تجاری جزیره کیش',
    image: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=800&auto=format&fit=crop',
    startDate: '2026-09-10',
    endDate: '2026-09-15',
    visibility: 'public',
    status: 'planning',
    createdAt: '2026-06-10T10:00:00.000Z',
    updatedAt: '2026-06-12T10:00:00.000Z',
  },
  {
    id: '4',
    title: 'کوهنوردی و صعود به قله دماوند',
    origin: 'تهران',
    destination: 'دماوند',
    description: 'صعود از یال جنوبی به همراه تجهیزات کامل کوهنوردی و همنوردان',
    image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=800&auto=format&fit=crop',
    startDate: '2026-08-15',
    endDate: '2026-08-18',
    visibility: 'public',
    status: 'planning',
    createdAt: '2026-06-05T10:00:00.000Z',
    updatedAt: '2026-06-18T10:00:00.000Z',
  },
  {
    id: '5',
    title: 'سفر فرهنگی و تاریخی به شیراز',
    origin: 'تهران',
    destination: 'شیراز',
    description: 'بازدید از تخت جمشید، حافظیه، سعدیه، ارگ کریم‌خان و باغ ارم',
    image: 'https://images.unsplash.com/photo-1541432901042-2d8bd64b4a9b?w=800&auto=format&fit=crop',
    startDate: '2026-10-01',
    endDate: '2026-10-05',
    visibility: 'private',
    status: 'planning',
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-06-20T10:00:00.000Z',
  },
  {
    id: 'mock-trip-1',
    title: 'سفر به استانبول',
    origin: 'تهران',
    destination: 'استانبول',
    description: 'سفر ۵ روزه با دوستان',
    startDate: '2026-08-01',
    endDate: '2026-08-06',
    visibility: 'private',
    status: 'planning',
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-06-15T10:00:00.000Z',
  },
  {
    id: 'mock-trip-2',
    title: 'تور شمال و کلاردشت',
    origin: 'تهران',
    destination: 'مازندران',
    description: 'سفر آخر هفته',
    startDate: '2026-07-20',
    endDate: '2026-07-22',
    visibility: 'public',
    status: 'upcoming',
    createdAt: '2026-05-10T10:00:00.000Z',
    updatedAt: '2026-06-01T10:00:00.000Z',
  },
];

export function getMockTrips(): Promise<Trip[]> {
  return Promise.resolve(mockTrips.slice(0, 5));
}
